import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { SystemUserUiSettings } from "../../../../modules/SystemUser/pages/_redux/system-user-childs/SystemUserUiSettings";
import axios from "axios";

export const UnmappedFileReroute = (props) => {
  useEffect(() => {
    new SystemUserUiSettings().SetSessionVars(
      props.match.params.guid,
      props.match.params.userType
    );
    let filePath = props.location.pathname.split(
      `/${props.match.params.userType}/`
    );
    console.log(filePath[filePath.length - 1]);
    let fileExtension = filePath[filePath.length - 1].split(".");
    // axios
    //   .post(
    //     `${process.env.REACT_APP_API_BASE_URL}aws-file`, { filePath: filePath[filePath.length - 1] }, { headers: { responseType: 'blob' } }
    //   ).then((response) => response.data)
    //   .then((res) => {
    //     const blob = new Blob(
    //       [res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
    //     const aEle = document.createElement('a');     // Create a label
    //     const href = window.URL.createObjectURL(blob);       // Create downloaded link
    //     aEle.href = href;
    //     aEle.download = 'download.'+fileExtension[fileExtension.length - 1];  // File name after download
    //     document.body.appendChild(aEle);
    //     aEle.click();     // Click to download
    //     document.body.removeChild(aEle); // Download complete remove element
    //     window.URL.revokeObjectURL(href) // Release blob object
    //   })

    sessionStorage.setItem("lastUnmappedFile", filePath[1]);
  }, []);

  return <Redirect from="/invoice/:guid/:userType/:fileUrl" to="/invoice" />;
};
